import { LocalizationProvider, ToastProvider } from '@tov-plus/ui';
import { ConnectivityProvider } from '@tov-plus/pwa';
import { TovQueryProvider } from '@tov-plus/frontend-data';
import { RouterProvider } from '@tov-plus/frontend-data';

import { router } from './router';

export function App() {
  return (
    <LocalizationProvider>
      <ConnectivityProvider>
        <TovQueryProvider appName="guests">
          <ToastProvider>
            <RouterProvider router={router} />
          </ToastProvider>
        </TovQueryProvider>
      </ConnectivityProvider>
    </LocalizationProvider>
  );
}
